const Content = {
  'homepage': {
    'line1': 'Ideas are born in the gut ...',
    'line2': '... but only after a thorough examination and understanding of all possibilities ...',
    'line3': 'does that idea lead to creative strategy',
    'line4': 'and',
    'line5': 'a story that connects with consumers.'
  }
};

export { Content };
